import { Box, Button, Grid } from "@mui/material";
import FormikControl from "components/wrapperComponents/FormikControl";
import { FieldArray, Form, Formik } from "formik";
import { MailRequestModel } from "model/utilModels/MailRequestModel";
import { useEffect, useRef, useState } from "react";
import "react-quill/dist/quill.snow.css";
import './MailRequestForm.scss';
import { RequestQuotesService } from "services/menu/requestQuotesOverviewService/RequestQuotesOverviewService";
import { msgTypes } from "constants/msgTypes";
import { useNavigate } from 'react-router-dom';
import { MailRequestSchema } from "schemas/utilSchema/MailRequestSchema";
import { UtilService } from "services/shared/UtilService";
import AttachFileIcon from '@mui/icons-material/AttachFile';
import ReactQuill from "react-quill";

const MailRequestForm = (props) => {
  var { mailrequestModel, setFlag } = props;
  const [initialValue, setInitialValue] = useState(new MailRequestModel())
  const [viewMode, setViewMode] = useState(false);
  const formikRef = useRef(null)
  const navigate = useNavigate();
  const [mailTo, setMailTo] = useState('');
  const [editorValue, setEditorValue] = useState("");

  useEffect(() => {
    // setMailTo(mailrequestModel.to.toString());
    mailrequestModel.from = mailrequestModel.to.toString()
    setInitialValue(mailrequestModel)
  }, [mailrequestModel])


  // Handle changes in the editor
  const handleEditorChange = (value) => {
    setEditorValue(value);
  };


  const sendRequest = async (values: MailRequestModel, { resetForm }) => {
    mailrequestModel.subject = values.subject;
    //mailrequestModel.body = values.body;
    mailrequestModel.body = editorValue;
    // mailrequestModel.cc = values.cc;
    if (values.cc) {
      if (Array.isArray(values.cc)) {
        mailrequestModel.cc = values.cc.map((email: string) => email.trim());
      } else {
        mailrequestModel.cc = values.cc.split(",").map((email: string) => email.trim());
      }
    } else {
      mailrequestModel.cc = [];
    }

    //mailrequestModel.attachment.push(values.attachment);
    const isEmpty = Object.keys(values.attachment[0]).length === 0;
    if (!isEmpty) {
      if (values.attachment.length) {
        mailrequestModel.attachment = await Promise.all(
          values.attachment.map(async (data: any) =>
            data ? await UtilService.getImagePath(data.file) : ""
          )
        );
      }
    } else {
      mailrequestModel.attachment = [];
    }


    const res = await RequestQuotesService.addRequestQuotes(mailrequestModel);
    if (res.statusMsg === msgTypes.SUCCESS.msg) {
      resetForm();
      setInitialValue(new MailRequestModel());
      setFlag(false);
      setEditorValue('');
    }
  };



  const styles = {
    typo: {
      marginBottom: "5px",
      fontWeight: "bold",
      color: "blue",
    },
    label: {
      fontWeight: "bold",
      fontSize: "15px",
      marginBottom: "5px",
      marginLeft: "20px",
    },
    textField: {
      marginBottom: "10px",
    },
    paper: {
      padding: "10px",
      margin: "10px 0",
      height: "auto",
    },
  };

  return (
    <Box className="main-box" width="100%" margin="0 auto" padding="5px">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <h4 className="mail-request-heading">
              Send Inquiry
            </h4>
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <Formik
              enableReinitialize={true}
              initialValues={initialValue}
              validationSchema={MailRequestSchema}
              innerRef={formikRef}
              onSubmit={sendRequest}
            >

              {({ dirty, isValid, values }) => (
                <Form>
                  <div className="row message-request-form pl-5">
                    <div className="col-lg-12">
                      <div className="row align-items-baseline">
                        <div className="col-md-12 message-quotes-display">
                          <div className="label-text-right">
                            <label>To</label>
                          </div>
                          <FormikControl
                            control="textfield"
                            name="to"
                            placeholder="To"
                            disabled={true}
                            // requiredField
                            sx={styles.textField}
                            value={mailrequestModel.to}
                          />
                        </div>
                      </div>
                      <div className="row align-items-baseline">
                        <div className="col-md-12 message-quotes-display">
                          <div className="label-text-right">
                            <label>CC</label>
                          </div>
                          <FormikControl
                            control="textfield"
                            name="cc"
                            placeholder="CC"
                            disabled={viewMode}
                            fullWidth
                            sx={styles.textField}
                          />
                        </div>
                      </div>
                      <div className="row align-items-baseline">
                        <div className="col-md-12 message-quotes-display">
                          <div className="label-text-right">
                            <label>BCC</label>
                          </div>
                          <FormikControl
                            control="textfield"
                            name="bcc"
                            placeholder="BCC"
                            disabled={true}
                            fullWidth
                            sx={styles.textField}
                          />
                        </div>
                      </div>
                      <div className="row align-items-baseline">
                        <div className="col-md-12 message-quotes-display">
                          <div className="label-text-right">
                            <label>Subject</label>
                          </div>
                          <FormikControl
                            control="textfield"
                            name="subject"
                            placeholder="Subject"
                            disabled={viewMode}
                            fullWidth
                            // requiredField
                            sx={styles.textField}
                          />

                        </div>
                      </div>
                      <div className="row align-items-baseline">
                        <div className="col-md-12 message-quotes-display">
                          <div className="label-text-right">
                            <label>Body</label>
                          </div>
                          {/* <FormikControl
                            control="richTextEditor"
                            name="body"
                            fullWidth
                          // requiredField
                          /> */}
                          <ReactQuill
                            value={editorValue}
                            onChange={handleEditorChange}
                            theme="snow" // The editor theme, can also use "bubble"
                            modules={msgTypes.TEXT_EDITOR_MODULE} // Optional, to customize the toolbar (explained below)
                          />
                        </div>
                      </div>

                      <div className="row align-items-baseline">
                        <div className="col-md-12 message-quotes-display">
                          <div className="align-items-center d-block pt-1 label-text-right">
                            <label>Attachment</label>
                          </div>
                          {/* <FormikControl control='uploadImage'
                            name="attachmentFile"
                            nameUrl="attachment"
                            disabled={viewMode}
                          /> */}
                          <div>

                            <FieldArray name="attachment">
                              {({ push }) => (
                                <>
                                  {values.attachment.map((file, index) => (
                                    <Grid
                                      container
                                      item
                                      xs={12}
                                      spacing={2}
                                      key={index}
                                    >
                                      <div className="row w-100 p-1">
                                        <div className="col-10">
                                          <FormikControl
                                            control="uploadImage"
                                            name={`attachment[${index}].file`}
                                            // label="Upload Communication"
                                            nameUrl={`attachment${index}`}
                                          />
                                        </div>
                                        {index === 0 &&
                                          JSON.stringify(
                                            values.attachment[0]
                                          ) !== "{}" && (
                                            <div className="col-2 d-flex align-items-center">
                                              <Button
                                                type="button"
                                                variant="contained"
                                                color="primary"
                                                onClick={() =>
                                                  push({ file: null })
                                                }
                                                fullWidth
                                                className="add-mores-button added-plus mt-0"
                                              >
                                                <AttachFileIcon />
                                              </Button>
                                            </div>
                                          )}
                                      </div>
                                    </Grid>
                                  ))}
                                </>
                              )}
                            </FieldArray>
                          </div>
                        </div>
                      </div>



                      <div className="row my-3">
                        <div className="col-md-12 text-end">
                          <FormikControl
                            control="button"
                            className="btn btn-submit"
                            color="primary"
                            label="Send Request"
                            type="submit"
                            disabled={!dirty || !isValid}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </Form>
              )}
            </Formik >
          </div>
        </div>
      </div>
    </Box>
  );
};

export default MailRequestForm;
